var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgMultinodeSupportStandardEnterprise = function SvgMultinodeSupportStandardEnterprise(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 40",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fill: "#a61fe0",
    d: "M20 2a18 18 0 100 36 18 18 0 100-36z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8h24v24H8z",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12a1 1 0 11-1 1 1.001 1.001 0 011-1m0-2a3 3 0 103 3 3 3 0 00-3-3zm7 9a1 1 0 11-1 1 1.001 1.001 0 011-1m0-2a3 3 0 103 3 3 3 0 00-3-3zm-7 9a1 1 0 11-1 1 1.001 1.001 0 011-1m0-2a3 3 0 103 3 3 3 0 00-3-3zm-7-5a1 1 0 11-1 1 1.001 1.001 0 011-1m0-2a3 3 0 103 3 3 3 0 00-3-3zm6.207-1.793l-1.414-1.414-3 3 1.414 1.414zm7 2.586l-3-3-1.414 1.414 3 3zm-1 5.414l-1.414-1.414-3 3 1.414 1.414zm-7 .586l-3-3-1.414 1.414 3 3z",
    fill: "#a61fe0"
  })));
};
export default SvgMultinodeSupportStandardEnterprise;